import { cockpit } from "@/api";
import type { OwnerTenantRuleParameters, OwnerRuleValueDelegation, UpdateTenantRuleParametersInput, RuleValuePreview } from "@/api";

export type RuleValuesEditorData = OwnerTenantRuleParameters & { delegation?: OwnerRuleValueDelegation };
export type RuleValuesEdit = UpdateTenantRuleParametersInput & { expected_delegation_version: number };

/** The shared editor owns drafts and conflicts; each plane keeps its own server authority. */
export interface RuleValuesAdapter {
  plane: "platform" | "business";
  load: () => Promise<RuleValuesEditorData>;
  save: (input: RuleValuesEdit) => Promise<RuleValuesEditorData>;
  preview?: (input: RuleValuesEdit) => Promise<RuleValuePreview>;
}

export function ownerRuleValuesAdapter(tenantId: string): RuleValuesAdapter {
  return {
    plane: "platform",
    load: () => cockpit.getTenantRuleParameters(tenantId),
    save: ({ expected_version, values }) => cockpit.updateTenantRuleParameters(tenantId, { expected_version, values }),
  };
}

export const businessRuleValuesAdapter: RuleValuesAdapter = {
  plane: "business",
  load: () => cockpit.getBusinessRuleValues(),
  save: (input) => cockpit.updateBusinessRuleValues(input),
  preview: (input) => cockpit.previewBusinessRuleValues(input),
};
